import styled from 'styled-components';
import { ensurePxUnit } from '../utils/mobileUtils';

export const ItemWrapper = styled.div.attrs(props => ({
    style: {
        marginTop: ensurePxUnit(props.control.margins?.top || 0),
        marginBottom: ensurePxUnit(props.control.margins?.bottom || 0),
    }
}))`
    position: relative;
    border-top: 2px solid transparent;
    border-bottom: 2px solid transparent;
    padding: 0; 
    cursor: pointer;

    /* Apply the indicator style when active */
    border-top-color: ${({ showIndicator }) => (showIndicator === 'top' ? '#F89B3C' : 'transparent')};
    border-bottom-color: ${({ showIndicator }) => (showIndicator === 'bottom' ? '#F89B3C' : 'transparent')};
`;

export const SelectionHighlight = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 2px;
    pointer-events: none; 
    box-shadow: ${({ isSelected }) => (isSelected ? '0 0 0 3px #F89B3C' : 'none')};
`;